import Axios from "axios";

const axios = Axios.create({
  baseURL: "https://badge.mg.formafusion.io/api",
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 100000,
});

// Request interceptor avec rate limiting
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);



// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    if (
      status === 401 &&
      !["/login", "/register"].some((path) => url.includes(path))
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.clear();
    }

    return Promise.reject(error);
  }
);

// Fonction pour récupérer l'utilisateur connecté
export const fetchCurrentUser = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      console.log("Aucun token trouvé");
      return null;
    }

    const response = await axios.get('/user'); // ou l'endpoint approprié
    console.log("Utilisateur récupéré:", response.data);
    return response.data;
  } catch (error) {
    console.error("Erreur récupération utilisateur:", error);
    return null;
  }
};

export default axios;